import { render, staticRenderFns } from "./add_servicio.vue?vue&type=template&id=e8ab933a&scoped=true"
import script from "./add_servicio.vue?vue&type=script&lang=js"
export * from "./add_servicio.vue?vue&type=script&lang=js"
import style0 from "./add_servicio.vue?vue&type=style&index=0&id=e8ab933a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8ab933a",
  null
  
)

export default component.exports